module.exports = __webpack_public_path__ + "images/RBL_PNB_IPO809a30c6a31f4fb3062ff19597f908d8.jpg";